import React, { useState, useEffect, useCallback } from 'react';

const ConsentContext = React.createContext(null);

export const useConsent = () => {
    const ctx = React.useContext(ConsentContext);
    if (!ctx) {
        throw new Error('useConsent must be used within ConsentProvider');
    }
    return ctx;
};

export const ConsentProvider = ({ children, consentRequired }) => {
    const [hasConsent, setHasConsent] = useState(() => {
        if (!consentRequired) return true;
        const stored = localStorage.getItem('aa-consent');
        return stored === 'accepted';
    });

    const [bannerVisible, setBannerVisible] = useState(() => {
        if (!consentRequired) return false;
        const stored = localStorage.getItem('aa-consent');
        return stored === null; // Show banner if no choice made
    });

    // Sync with consentRequired prop changes
    useEffect(() => {
        if (!consentRequired && !hasConsent) {
            setHasConsent(true);
            setBannerVisible(false);
        }
    }, [consentRequired, hasConsent]);

    const accept = useCallback(() => {
        localStorage.setItem('aa-consent', 'accepted');
        setHasConsent(true);
        setBannerVisible(false);
    }, []);

    const reject = useCallback(() => {
        localStorage.setItem('aa-consent', 'rejected');
        setHasConsent(false);
        setBannerVisible(false);
    }, []);

    const value = {
        hasConsent,
        consentRequired,
        bannerVisible,
        accept,
        reject,
        showBanner: () => setBannerVisible(true),
        hideBanner: () => setBannerVisible(false),
    };

    return (
        <ConsentContext.Provider value={value}>
            {children}
        </ConsentContext.Provider>
    );
};
